import { InjectionToken } from '@angular/core';

export const ORIGIN_URL = new InjectionToken<string>('ORIGIN_URL');



// WEBPACK FOOTER //
// ./Client/app/shared/constants/baseurl.constants.ts